import ApiResponse from "../resources/domain/entity/IApiResponse";
import * as http from "../util/http";
import endpoint from "../constants/endpoint";

export const session = (data:any): Promise<ApiResponse> => {
    return http.post(`${endpoint.Session.SESSION}`,data);
  };
